import React, {useContext, useEffect, useState} from "react";
import { Observable, map, debounceTime, distinctUntilChanged } from "rxjs";
import $ from "jquery";
import Search2Icon from "../icons/Search2Icon";
import ListingContext from "../../context/ListingContext";
import "../../css/toolsBar/FilterPopup.css";
import usePrevious from "../../class/tool/usePrevious";
import StringTools from "../../class/tool/StringTools";
import CancelIcon from "../icons/CancelIcon";
import stringTools from "../../class/tool/StringTools";

const FilterPopup = () => {
    const { typeFilters, showFilters, closeFilters, validFilters, filters, filterValues } = useContext(ListingContext);
    const [ values, setValues ] = useState({});
    const [ extend, setExtend ] = useState(false);
    const [ extendDatas, setExtendDatas ] = useState(null);
    const prevTypeFilters = usePrevious(typeFilters);
    const prevFilterValues = usePrevious(filterValues);

    const initSearching = () => {
        switch (typeFilters) {
            case "statistics":
                return;
            default:
                const input = document.querySelector("#searchBarInput");
                const inputSearch$ = new Observable(observer => {
                    input.addEventListener("input", (event) => {
                        observer.next(event);
                    })
                });
                const inputed$ = inputSearch$.pipe(
                    map((event) => event.target.value),
                    debounceTime(500),
                    distinctUntilChanged()
                );

                inputed$.subscribe(value => {
                changeInput(value);
            });
                break;
        }
    }
    const buildSearchBar = () => {
        switch (typeFilters) {
            case "statistics":
                return;
            default:
                return <div className={"searchBar"}>
                    <Search2Icon />
                    <input type={"text"} id={"searchBarInput"} name={"input"} placeholder={"Rechercher"} onKeyUp={search} />
                </div>;
        }
    }
    const buildInputs = () => {
        if (values === undefined || values === null || values.inputs === undefined || values.inputs === null || values.inputs.length === 0)
            return;

        const dictAttribute = {
            "name": "Nom",
            "lastname": "Nom",
            "firstname": "Prénom",
            "reference": "Référence",
            "barcode": "Code barre",
            "price": "Prix"
        }
        const dictConstraint = {
            "begin": "Commence par",
            "end": "Termine par",
            "contains": "Contient",
            "<": "Jusqu'à",
            ">": "À partir de"
        }

        return <div className={"containerInputs"}>
            {
                values.inputs.map((input, index) => (
                    <div key={index} className={"filter"}>
                        <div className={"struct"}>
                            <div className={"close"} onClick={() => { removeExtend("inputs", input); }}><CancelIcon /></div>
                            <p className={"attribute"}>{ dictAttribute[input.attribute] }</p>
                            <p className={"type"}>{ dictConstraint[input.constraint] }</p>
                        </div>
                        <p className={"value"}>{ buildValue(input) }</p>
                    </div>
                ))
            }
        </div>
    }
    const buildValue = input => {
        if (input.attribute === "price")
            return stringTools.number_format(input.value, 2, ",", " ") + (input.attribute === "price" ? " €" : "");
        else
            return input.value;
    }
    const buildFilter = (attribute, index) => {
        switch (typeFilters) {
            case "pricelists":
            case "categories":
                if (filters[attribute] === undefined || filters[attribute] === null)
                    return;

                switch (attribute) {
                    case "catalogs":
                        if (filters[attribute].length < 2)
                            return;

                        return <div key={index} className={"filter"}>
                            <label className={"label"} htmlFor={"category"}>Catalogue</label>
                            <select key={index} name={"catalog"} value={values.catalog_id !== null ? values.catalog_id : -1} onChange={(e) => { select(e, attribute) }}>
                                {
                                    filters[attribute].map((item, index) => (
                                        <option key={index} value={item.id}>{item.name}</option>
                                    ))
                                }
                            </select>
                        </div>;
                    default: break;
                }
                break;
            case "subCategories":
                if (filters[attribute] === undefined || filters[attribute] === null)
                    return;

                switch (attribute) {
                    case "catalogs":
                        if (filters[attribute].length < 2)
                            return;

                        return <div key={index} className={"filter"}>
                            <label className={"label"} htmlFor={"category"}>Catalogue</label>
                            <select key={index} name={"catalog"} value={values.catalog_id !== null ? values.catalog_id : -1} onChange={(e) => { select(e, attribute) }}>
                                {
                                    filters[attribute].map((item, index) => (
                                        <option key={index} value={item.id}>{item.name}</option>
                                    ))
                                }
                            </select>
                        </div>;
                    case "categories":
                        if (filters[attribute].length < 2)
                            return;

                        return <div key={index} className={"filter"}>
                            <label className={"label"} htmlFor={"category"}>Catégorie</label>
                            <select name={"category"} value={(values.category_id === null ? -1 : values.category_id)} onChange={(e) => { select(e, attribute) }}>
                                {
                                    filters[attribute].map((item, index) => (
                                        <option key={index} value={item.id}>{item.name}</option>
                                    ))
                                }
                            </select>
                        </div>;
                    default: break;
                }
                break;
            case "products":
                if (filters[attribute] === undefined || filters[attribute] === null)
                    return;

                switch (attribute) {
                    case "catalogs":
                        if (filters[attribute].length < 2)
                            return;

                        return <div key={index} className={"filter"}>
                            <label className={"label"} htmlFor={"category"}>Catalogue</label>
                            <select key={index} name={"catalog"} value={values.catalog_id !== null ? values.catalog_id : -1} onChange={(e) => { select(e, attribute) }}>
                                {
                                    filters[attribute].map((item, index) => (
                                        <option key={index} value={item.id}>{item.name}</option>
                                    ))
                                }
                            </select>
                        </div>;
                    case "categories":
                        if (filters[attribute].length < 2)
                            return;

                        return <div key={index} className={"filter"}>
                            <label className={"label"} htmlFor={"category"}>Catégorie</label>
                            <select name={"category"} value={(values.category_id === null ? -1 : values.category_type + "_" + values.category_id)} onChange={(e) => { select(e, attribute) }}>
                                {
                                    filters[attribute].map((item, index) => (
                                        <option key={index} value={(item.type.length > 0 ? item.type + "_": "") + item.id}>{item.name}</option>
                                    ))
                                }
                            </select>
                        </div>;
                    case "vatRates":
                        if (filters[attribute].length < 2)
                            return;

                        return <div key={index} className={"filter"}>
                            <label className={"label"} htmlFor={"category"}>TVA</label>
                            <select key={index} name={"vatRate"} value={values.vat_rate_id !== null ? values.vat_rate_id : -1} onChange={(e) => { select(e, attribute) }}>
                                {
                                    filters[attribute].map((item, index) => (
                                        <option key={index} value={item.id}>{item.name}</option>
                                    ))
                                }
                            </select>
                        </div>;
                    case "tags":
                        if (filters[attribute].length < 2)
                            return;

                        return <select key={index} name={"tag"} onChange={(e) => { select(e, attribute) }}>
                            {
                                filters[attribute].map((item, index) => (
                                    <option key={index} value={item.id}>{item.name}</option>
                                ))
                            }
                        </select>;
                    case "variablePrice":
                        if (filters[attribute].length < 2)
                            return;

                        return <div key={index} className={"filter"}>
                            <label className={"label"} htmlFor={"category"}>Prix variable</label>
                            <select key={index} name={"category"} value={(values.variablePrice === null ? -1 : values.variablePrice)} onChange={(e) => { select(e, attribute) }}>
                                {
                                    filters[attribute].map((item, index) => (
                                        <option key={index} value={item.id}>{item.name}</option>
                                    ))
                                }
                            </select>
                        </div>;
                    default: break;
                }
                break;
            case "sellers":
                if (filters[attribute] === undefined || filters[attribute] === null)
                    return;

                switch (attribute) {
                    case "sellerGroups":
                        if (filters[attribute].length < 2)
                            return;

                        return <div key={index} className={"filter"}>
                            <label className={"label"} htmlFor={"sellerGroup"}>Groupe vendeur</label>
                            <select key={index} name={"sellerGroup"} value={values.group_id !== null ? values.group_id : -1} onChange={(e) => { select(e, attribute) }}>
                                {
                                    filters[attribute].map((item, index) => (
                                        <option key={index} value={item.id}>{item.name}</option>
                                    ))
                                }
                            </select>
                        </div>;
                    default: break;
                }
                break;
            case "printers":
            case "displays":
            case "barcodeReaders":
            case "terminalPayments":
            case "automaticDrawers":
                if (filters[attribute] === undefined || filters[attribute] === null)
                    return;

                switch (attribute) {
                    case "licenses":
                        if (filters[attribute].length < 2)
                            return;

                        return <div key={index} className={"filter"}>
                            <label className={"label"} htmlFor={"license"}>Licence</label>
                            <select key={index} name={"license"} value={values.license_id !== null ? values.license_id : -1} onChange={(e) => { select(e, attribute) }}>
                                {
                                    filters[attribute].map((item, index) => (
                                        <option key={index} value={item.id}>{item.name}</option>
                                    ))
                                }
                            </select>
                        </div>;
                    case "interfaceTypes":
                        if (filters[attribute].length < 2)
                            return;

                        return <div key={index} className={"filter"}>
                            <label className={"label"} htmlFor={"interfaceType"}>Interface</label>
                            <select key={index} name={"interfaceType"} value={values.interfaceType !== null ? values.interfaceType : -1} onChange={(e) => { select(e, attribute) }}>
                                {
                                    filters[attribute].map((item, index) => (
                                        <option key={index} value={item.id}>{item.name}</option>
                                    ))
                                }
                            </select>
                        </div>;
                    case "brands":
                        if (filters[attribute].length < 2)
                            return;

                        return <div key={index} className={"filter"}>
                            <label className={"label"} htmlFor={"brand"}>Marque</label>
                            <select key={index} name={"brand"} value={values.brand !== null ? values.brand : -1} onChange={(e) => { select(e, attribute) }}>
                                {
                                    filters[attribute].map((item, index) => (
                                        <option key={index} value={item.id}>{item.name}</option>
                                    ))
                                }
                            </select>
                        </div>;
                    default: break;
                }
                break;
            case "statistics":
                if (filters[attribute] === undefined || filters[attribute] === null)
                    return;

                switch (attribute) {
                    case "licenses":
                        if (filters[attribute].length < 2)
                            return;

                        return <div key={index} className={"filter"}>
                            <label className={"label"} htmlFor={"license"}>Caisses</label>
                            <select key={index} name={"license"} value={values.license_id !== null ? values.license_id : -1} onChange={(e) => { select(e, attribute) }}>
                                {
                                    filters[attribute].map((item, index) => (
                                        <option key={index} value={item.id}>{item.name}</option>
                                    ))
                                }
                            </select>
                        </div>;
                    case "sellers":
                        if (filters[attribute].length < 2)
                            return;

                        return <div key={index} className={"filter"}>
                            <label className={"label"} htmlFor={"seller"}>Vendeurs</label>
                            <select key={index} name={"seller"} value={values.seller_id !== null ? values.seller_id : -1} onChange={(e) => { select(e, attribute) }}>
                                {
                                    filters[attribute].map((item, index) => (
                                        <option key={index} value={item.id}>{item.name}</option>
                                    ))
                                }
                            </select>
                        </div>;
                    default: break;
                }
                break;
            default: break;
        }
    }
    const initInput = () => {
        if (showFilters)
            $("#searchBarInput").focus();
        else
            $("#searchBarInput").blur();
    }
    const search = event => {
        if (event.key === "Enter") {
            event.preventDefault();
            valid();
        }
        else {
            let value = event.currentTarget.value;
            setValues(prev => ({
                ...prev,
                input: value
            }));
        }
    }
    const changeInput = value => {
        if (value.length === 0)
            closeExtend();
        else {
            const type = detectInputType(value);

            setExtend(true);
            setExtendDatas({
                type: type,
                value: value
            });
        }
    }
    const detectInputType = value => {
        let type = "";
        const priceRegex = /^\d+([.,])?(\d{1,2})?$/i;
        const numberRegex = /^\d{1,}$/i;

        switch (typeFilters) {
            case "catalogs":
            case "pricelists":
            case "categories":
            case "subCategories":
            case "sellerGroups":
            case "printers":
            case "displays":
            case "barcodeReaders":
            case "paymentTerminals":
            case "automaticDrawers":
                type = "name";
                break;
            case "products":
                if (numberRegex.test(value)) {
                    if (parseInt(value) >= 10000)
                        type = "barcode";
                    else
                        type = "number";
                }

                if (type === "") {
                    if (priceRegex.test(value))
                        type = "price";
                }

                if (type === "")
                    type = "name";

                break;
            case "sellers":
                if (numberRegex.test(value))
                    type = "number";

                if (type === "")
                    type = "name";

                break;
            default: break;
        }

        return type;
    }
    const select = (event, attribute) => {
        const value = event.currentTarget.value;

        switch (typeFilters) {
            case "catalogs":
            case "pricelists":
            case "categories":
                switch (attribute) {
                    case "catalogs":
                        if (parseInt(value) === -1) {
                            setValues(prev => ({
                                ...prev,
                                catalog_id: null
                            }));
                        }
                        else {
                            setValues(prev => ({
                                ...prev,
                                catalog_id: parseInt(value)
                            }));
                        }

                        break;
                    default: break;
                }

                break;
            case "subCategories":
                switch (attribute) {
                    case "catalogs":
                        if (parseInt(value) === -1) {
                            setValues(prev => ({
                                ...prev,
                                catalog_id: null
                            }));
                        }
                        else {
                            setValues(prev => ({
                                ...prev,
                                catalog_id: parseInt(value)
                            }));
                        }

                        break;
                    case "categories":
                        if (parseInt(value) === -1) {
                            setValues(prev => ({
                                ...prev,
                                category_id: null
                            }));
                        }
                        else {
                            setValues(prev => ({
                                ...prev,
                                category_id: value
                            }));
                        }

                        break;
                    default: break;
                }

                break;
            case "products":
                switch (attribute) {
                    case "catalogs":
                        if (parseInt(value) === -1) {
                            setValues(prev => ({
                                ...prev,
                                catalog_id: null
                            }));
                        }
                        else {
                            setValues(prev => ({
                                ...prev,
                                catalog_id: parseInt(value)
                            }));
                        }

                        break;
                    case "categories":
                        if (parseInt(value) === -1) {
                            setValues(prev => ({
                                ...prev,
                                category_type: "",
                                category_id: null
                            }));
                        }
                        else {
                            const explode = value.split("_");
                            setValues(prev => ({
                                ...prev,
                                category_type: explode[0],
                                category_id: parseInt(explode[1])
                            }));
                        }

                        break;
                    case "vatRates":
                        if (parseInt(value) === -1) {
                            setValues(prev => ({
                                ...prev,
                                vat_rate_id: null
                            }));
                        }
                        else {
                            setValues(prev => ({
                                ...prev,
                                vat_rate_id: parseInt(value)
                            }));
                        }

                        break;
                    case "variablePrice":
                        if (parseInt(value) === -1) {
                            setValues(prev => ({
                                ...prev,
                                variablePrice: null
                            }));
                        }
                        else {
                            setValues(prev => ({
                                ...prev,
                                variablePrice: parseInt(value)
                            }));
                        }

                        break;
                    default: break;
                }

                break;
            case "sellers":
                switch (attribute) {
                    case "sellerGroups":
                        if (parseInt(value) === -1) {
                            setValues(prev => ({
                                ...prev,
                                group_id: null
                            }));
                        }
                        else {
                            setValues(prev => ({
                                ...prev,
                                group_id: parseInt(value)
                            }));
                        }

                        break;
                    default: break;
                }

                break;
            case "printers":
            case "displays":
            case "barcodeReaders":
            case "paymentsTerminals":
            case "automaticDrawers":
                switch (attribute) {
                    case "licenses":
                        if (parseInt(value) === -1) {
                            setValues(prev => ({
                                ...prev,
                                license_id: null
                            }));
                        }
                        else {
                            setValues(prev => ({
                                ...prev,
                                license_id: parseInt(value)
                            }));
                        }

                        break;
                    case "interfaceTypes":
                        if (parseInt(value) === -1) {
                            setValues(prev => ({
                                ...prev,
                                interfaceType: null
                            }));
                        }
                        else {
                            setValues(prev => ({
                                ...prev,
                                interfaceType: parseInt(value)
                            }));
                        }

                        break;
                    case "brands":
                        if (parseInt(value) === -1) {
                            setValues(prev => ({
                                ...prev,
                                brand: null
                            }));
                        }
                        else {
                            setValues(prev => ({
                                ...prev,
                                brand: parseInt(value)
                            }));
                        }

                        break;
                    default: break;
                }

                break;
            case "statistics":
                switch (attribute) {
                    case "licenses":
                        if (parseInt(value) === -1) {
                            setValues(prev => ({
                                ...prev,
                                license_id: null
                            }));
                        }
                        else {
                            setValues(prev => ({
                                ...prev,
                                license_id: parseInt(value)
                            }));
                        }

                        break;
                    case "sellers":
                        if (parseInt(value) === -1) {
                            setValues(prev => ({
                                ...prev,
                                seller_id: null
                            }));
                        }
                        else {
                            setValues(prev => ({
                                ...prev,
                                seller_id: parseInt(value)
                            }));
                        }

                        break;
                    default: break;
                }

                break;
            default: break;
        }
    }
    const valid = () => {
        closeExtend();
        validFilters(values);
    }
    const close = () => {
        setValues(prev => ({
            ...prev,
            input: null
        }));
        $("#searchBarInput").val("");

        closeExtend();
        closeFilters();
    }
    const closeExtend = () => {
        setExtend(false);

        setTimeout(() => { setExtendDatas(null); }, 250);
    }
    const buildExtend = () => {
        if (extendDatas === null)
            return;

        switch (typeFilters) {
            case "catalogs":
            case "pricelists":
            case "sellerGroups":
            case "printers":
            case "displays":
            case "barcodeReaders":
            case "paymentTerminals":
            case "automaticDrawers":
                switch (extendDatas.type) {
                    case "name":
                        return <>
                            <p className={"title"}>Nom</p>
                            <div className={"item"} onClick={() => { selectExtend("name", "begin", extendDatas.value); }}>
                                <p className={"constraint"}>Commence par</p>
                                <p className={"value"}>{ extendDatas.value }</p>
                            </div>
                            <div className={"item"} onClick={() => { selectExtend("name", "end", extendDatas.value); }}>
                                <p className={"constraint"}>Termine par</p>
                                <p className={"value"}>{ extendDatas.value }</p>
                            </div>
                            <div className={"item"} onClick={() => { selectExtend("name", "contains", extendDatas.value); }}>
                                <p className={"constraint"}>Contient</p>
                                <p className={"value"}>{ extendDatas.value }</p>
                            </div>
                        </>;
                    default: break;
                }

                break;
            case "categories":
            case "subCategories":
                switch (extendDatas.type) {
                    case "name":
                        return <>
                            <p className={"title"}>Nom</p>
                            <div className={"item"} onClick={() => { selectExtend("name", "begin", extendDatas.value); }}>
                                <p className={"constraint"}>Commence par</p>
                                <p className={"value"}>{ extendDatas.value }</p>
                            </div>
                            <div className={"item"} onClick={() => { selectExtend("name", "end", extendDatas.value); }}>
                                <p className={"constraint"}>Termine par</p>
                                <p className={"value"}>{ extendDatas.value }</p>
                            </div>
                            <div className={"item"} onClick={() => { selectExtend("name", "contains", extendDatas.value); }}>
                                <p className={"constraint"}>Contient</p>
                                <p className={"value"}>{ extendDatas.value }</p>
                            </div>
                            <p className={"title"}>Référence</p>
                            <div className={"item"} onClick={() => { selectExtend("reference", "begin", extendDatas.value); }}>
                                <p className={"constraint"}>Commence par</p>
                                <p className={"value"}>{ extendDatas.value }</p>
                            </div>
                            <div className={"item"} onClick={() => { selectExtend("reference", "end", extendDatas.value); }}>
                                <p className={"constraint"}>Termine par</p>
                                <p className={"value"}>{ extendDatas.value }</p>
                            </div>
                            <div className={"item"} onClick={() => { selectExtend("reference", "contains", extendDatas.value); }}>
                                <p className={"constraint"}>Contient</p>
                                <p className={"value"}>{ extendDatas.value }</p>
                            </div>
                        </>;
                    default: break;
                }

                break;
            case "products":
                switch (extendDatas.type) {
                    case "price":
                        return <>
                            <p className={"title"}>Prix</p>
                            <div className={"item"} onClick={() => { selectExtend("price", ">", parseFloat(extendDatas.value.replace(",", "."))); }}>
                                <p className={"constraint"}>À partir de</p>
                                <p className={"value"}>{ StringTools.number_format(parseFloat(extendDatas.value.replace(",", ".")), 2, ",", " ") } €</p>
                            </div>
                            <div className={"item"} onClick={() => { selectExtend("price", "<", parseFloat(extendDatas.value.replace(",", "."))); }}>
                                <p className={"constraint"}>Jusqu'à</p>
                                <p className={"value"}>{ StringTools.number_format(parseFloat(extendDatas.value.replace(",", ".")), 2, ",", " ") } €</p>
                            </div>
                        </>;
                    case "number":
                        return <>
                            <p className={"title"}>Prix</p>
                            <div className={"item"} onClick={() => { selectExtend("price", ">", parseFloat(extendDatas.value.replace(",", "."))); }}>
                                <p className={"constraint"}>À partir de</p>
                                <p className={"value"}>{ StringTools.number_format(parseFloat(extendDatas.value.replace(",", ".")), 2, ",", " ") } €</p>
                            </div>
                            <div className={"item"} onClick={() => { selectExtend("price", "<", parseFloat(extendDatas.value.replace(",", "."))); }}>
                                <p className={"constraint"}>Jusqu'à</p>
                                <p className={"value"}>{ StringTools.number_format(parseFloat(extendDatas.value.replace(",", ".")), 2, ",", " ") } €</p>
                            </div>
                            <p className={"title"}>Code barre</p>
                            <div className={"item"} onClick={() => { selectExtend("barcode", "begin", extendDatas.value); }}>
                                <p className={"constraint"}>Commence par</p>
                                <p className={"value"}>{ extendDatas.value }</p>
                            </div>
                            <div className={"item"} onClick={() => { selectExtend("barcode", "end", extendDatas.value); }}>
                                <p className={"constraint"}>Termine par</p>
                                <p className={"value"}>{ extendDatas.value }</p>
                            </div>
                            <div className={"item"} onClick={() => { selectExtend("barcode", "contains", extendDatas.value); }}>
                                <p className={"constraint"}>Contient</p>
                                <p className={"value"}>{ extendDatas.value }</p>
                            </div>
                            <p className={"title"}>Référence</p>
                            <div className={"item"} onClick={() => { selectExtend("reference", "begin", extendDatas.value); }}>
                                <p className={"constraint"}>Commence par</p>
                                <p className={"value"}>{ extendDatas.value }</p>
                            </div>
                            <div className={"item"} onClick={() => { selectExtend("reference", "end", extendDatas.value); }}>
                                <p className={"constraint"}>Termine par</p>
                                <p className={"value"}>{ extendDatas.value }</p>
                            </div>
                            <div className={"item"} onClick={() => { selectExtend("reference", "contains", extendDatas.value); }}>
                                <p className={"constraint"}>Contient</p>
                                <p className={"value"}>{ extendDatas.value }</p>
                            </div>
                        </>;
                    case "barcode":
                        return <>
                            <p className={"title"}>Code barre</p>
                            <div className={"item"} onClick={() => { selectExtend("barcode", "begin", extendDatas.value); }}>
                                <p className={"constraint"}>Commence par</p>
                                <p className={"value"}>{ extendDatas.value }</p>
                            </div>
                            <div className={"item"} onClick={() => { selectExtend("barcode", "end", extendDatas.value); }}>
                                <p className={"constraint"}>Termine par</p>
                                <p className={"value"}>{ extendDatas.value }</p>
                            </div>
                            <div className={"item"} onClick={() => { selectExtend("barcode", "contains", extendDatas.value); }}>
                                <p className={"constraint"}>Contient</p>
                                <p className={"value"}>{ extendDatas.value }</p>
                            </div>
                        </>;
                    case "name":
                        return <>
                            <p className={"title"}>Nom</p>
                            <div className={"item"} onClick={() => { selectExtend("name", "begin", extendDatas.value); }}>
                                <p className={"constraint"}>Commence par</p>
                                <p className={"value"}>{ extendDatas.value }</p>
                            </div>
                            <div className={"item"} onClick={() => { selectExtend("name", "end", extendDatas.value); }}>
                                <p className={"constraint"}>Termine par</p>
                                <p className={"value"}>{ extendDatas.value }</p>
                            </div>
                            <div className={"item"} onClick={() => { selectExtend("name", "contains", extendDatas.value); }}>
                                <p className={"constraint"}>Contient</p>
                                <p className={"value"}>{ extendDatas.value }</p>
                            </div>
                            <p className={"title"}>Référence</p>
                            <div className={"item"} onClick={() => { selectExtend("reference", "begin", extendDatas.value); }}>
                                <p className={"constraint"}>Commence par</p>
                                <p className={"value"}>{ extendDatas.value }</p>
                            </div>
                            <div className={"item"} onClick={() => { selectExtend("reference", "end", extendDatas.value); }}>
                                <p className={"constraint"}>Termine par</p>
                                <p className={"value"}>{ extendDatas.value }</p>
                            </div>
                            <div className={"item"} onClick={() => { selectExtend("reference", "contains", extendDatas.value); }}>
                                <p className={"constraint"}>Contient</p>
                                <p className={"value"}>{ extendDatas.value }</p>
                            </div>
                        </>;
                    default: break;
                }

                break;
            case "sellers":
                switch (extendDatas.type) {
                    case "number":
                        return <>
                            <p className={"title"}>Code barre</p>
                            <div className={"item"} onClick={() => { selectExtend("barcode", "begin", extendDatas.value); }}>
                                <p className={"constraint"}>Commence par</p>
                                <p className={"value"}>{ extendDatas.value }</p>
                            </div>
                            <div className={"item"} onClick={() => { selectExtend("barcode", "end", extendDatas.value); }}>
                                <p className={"constraint"}>Termine par</p>
                                <p className={"value"}>{ extendDatas.value }</p>
                            </div>
                            <div className={"item"} onClick={() => { selectExtend("barcode", "contains", extendDatas.value); }}>
                                <p className={"constraint"}>Contient</p>
                                <p className={"value"}>{ extendDatas.value }</p>
                            </div>
                            <p className={"title"}>Référence</p>
                            <div className={"item"} onClick={() => { selectExtend("reference", "begin", extendDatas.value); }}>
                                <p className={"constraint"}>Commence par</p>
                                <p className={"value"}>{ extendDatas.value }</p>
                            </div>
                            <div className={"item"} onClick={() => { selectExtend("reference", "end", extendDatas.value); }}>
                                <p className={"constraint"}>Termine par</p>
                                <p className={"value"}>{ extendDatas.value }</p>
                            </div>
                            <div className={"item"} onClick={() => { selectExtend("reference", "contains", extendDatas.value); }}>
                                <p className={"constraint"}>Contient</p>
                                <p className={"value"}>{ extendDatas.value }</p>
                            </div>
                        </>;
                    case "name":
                        return <>
                            <p className={"title"}>Nom</p>
                            <div className={"item"} onClick={() => { selectExtend("lastname", "begin", extendDatas.value); }}>
                                <p className={"constraint"}>Commence par</p>
                                <p className={"value"}>{ extendDatas.value }</p>
                            </div>
                            <div className={"item"} onClick={() => { selectExtend("lastname", "end", extendDatas.value); }}>
                                <p className={"constraint"}>Termine par</p>
                                <p className={"value"}>{ extendDatas.value }</p>
                            </div>
                            <div className={"item"} onClick={() => { selectExtend("lastname", "contains", extendDatas.value); }}>
                                <p className={"constraint"}>Contient</p>
                                <p className={"value"}>{ extendDatas.value }</p>
                            </div>
                            <p className={"title"}>Prénom</p>
                            <div className={"item"} onClick={() => { selectExtend("firstname", "begin", extendDatas.value); }}>
                                <p className={"constraint"}>Commence par</p>
                                <p className={"value"}>{ extendDatas.value }</p>
                            </div>
                            <div className={"item"} onClick={() => { selectExtend("firstname", "end", extendDatas.value); }}>
                                <p className={"constraint"}>Termine par</p>
                                <p className={"value"}>{ extendDatas.value }</p>
                            </div>
                            <div className={"item"} onClick={() => { selectExtend("firstname", "contains", extendDatas.value); }}>
                                <p className={"constraint"}>Contient</p>
                                <p className={"value"}>{ extendDatas.value }</p>
                            </div>
                            <p className={"title"}>Référence</p>
                            <div className={"item"} onClick={() => { selectExtend("reference", "begin", extendDatas.value); }}>
                                <p className={"constraint"}>Commence par</p>
                                <p className={"value"}>{ extendDatas.value }</p>
                            </div>
                            <div className={"item"} onClick={() => { selectExtend("reference", "end", extendDatas.value); }}>
                                <p className={"constraint"}>Termine par</p>
                                <p className={"value"}>{ extendDatas.value }</p>
                            </div>
                            <div className={"item"} onClick={() => { selectExtend("reference", "contains", extendDatas.value); }}>
                                <p className={"constraint"}>Contient</p>
                                <p className={"value"}>{ extendDatas.value }</p>
                            </div>
                        </>;
                    default: break;
                }

                break;
            default: break;
        }
    }
    const selectExtend = (attribute, constraint, value) => {
        let inputs = values.inputs.slice();
        let index;

        switch (typeFilters) {
            case "catalogs":
            case "pricelists":
            case "categories":
            case "subCategories":
            case "sellerGroups":
            case "sellers":
            case "printers":
            case "displays":
            case "barcodeReaders":
            case "paymentTerminals":
            case "automaticDrawers":
                index = inputs.findIndex(_ => _.attribute === attribute);

                if (index >= 0) {
                    inputs[index] = {
                        attribute,
                        constraint,
                        value
                    };
                }
                else {
                        inputs.push({
                            attribute,
                            constraint,
                            value
                        });
                    }

                break;
            case "products":
                if (attribute === "price") {
                    index = inputs.findIndex(_ => _.attribute === attribute && _.constraint === constraint && _.value === value);

                    if (index < 0) {
                        inputs.push({
                            attribute,
                            constraint,
                            value
                        });
                    }
                }
                else {
                    index = inputs.findIndex(_ => _.attribute === attribute);

                    if (index >= 0) {
                        inputs[index] = {
                            attribute,
                            constraint,
                            value
                        };
                    }
                    else {
                        inputs.push({
                            attribute,
                            constraint,
                            value
                        });
                    }
                }

                break;
            default: break;
        }

        $("#searchBarInput").val("");
        setValues(prev => ({
            ...prev,
            inputs: inputs,
            input: null
        }));

        closeExtend();
    }
    const removeExtend = (attribute, target) => {
        let newValues = Object.assign({}, values);

        switch (attribute) {
            case "inputs":
                let inputs = newValues.inputs.slice();
                const index = inputs.findIndex(_ => _.attribute === target.attribute && _.constraints === target.constraints && _.value === target.value);

                if (index >= 0)
                    inputs.splice(index, 1);

                newValues.inputs = inputs;
                break;
            default: break;
        }

        setValues(newValues);
    }

    useEffect(() => {
        initInput();
    }, [showFilters]);
    useEffect(() => {
        if (prevTypeFilters !== typeFilters)
            initSearching();
    }, [typeFilters]);
    useEffect(() => {
        setValues(filterValues);

        if (prevFilterValues !== undefined && filterValues !== undefined && filterValues.input !== undefined)
            $("#searchBarInput").val(filterValues.input);
    }, [filterValues]);
    useEffect(() => {
        if (extend && !showFilters) {
            setExtend(false);
            setExtendDatas(null);
        }
    }, [extend, showFilters]);

    return(
        <>
            <div className={"overlayer hover" + (!showFilters ? " hidden" : "")} />
            <div className={"filterPopup" + (!showFilters ? " hidden" : "")}>
                <div className={"filters"}>
                    {
                        buildSearchBar()
                    }
                    {
                        buildInputs()
                    }
                    {
                        filters !== undefined
                        && Object.keys(filters).map((attribute, index) => buildFilter(attribute, index))
                    }
                </div>
                <div className={"actions"}>
                    <p className={"close"} onClick={close}>Fermer</p>
                    <p className={"valid"} onClick={valid}>Valider</p>
                </div>
            </div>
            <div className={"extendFilterPopup" + (!extend ? " hidden" : "")}>
                { buildExtend() }
            </div>
        </>
    );
}

export default FilterPopup;